module.exports = __webpack_public_path__ + "static/media/i4b.a9ab622d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i4b.svg
// module id = 356
// module chunks = 8